import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaSearchIcon: React.FC<IIconProps> = ({
  color,
  size = '35',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.alea[500];
  const width = parseInt(String(size), 10);
  const height = (34 / 35) * width;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0031 14.9598C24.0031 19.1767 20.4799 22.6198 16.1031 22.6198C11.7263 22.6198 8.20312 19.1767 8.20312 14.9598C8.20312 10.7429 11.7263 7.2998 16.1031 7.2998C20.4799 7.2998 24.0031 10.7429 24.0031 14.9598Z"
        stroke={iconColor}
      />
      <path
        d="M21.9923 21.0801L28.7022 27.5985"
        stroke={iconColor}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AleaSearchIcon; 